import type { AxiosHeaders } from 'axios';
import { api } from './index';
import type { ClinicalAuthor } from '../utils/clinical-author';
import type { ClinicalVoidable } from '../utils/clinical-void';

const BASE_PATH = '/api/internal/vital_sign_records';

export type VitalSignRecord = ClinicalVoidable & {
  id: number;
  patientId: number;
  shiftId: number;
  vitalSignId: number;
  value: string;
  recordedAt: string;
  bloodPressureRecordSystolic: number;
  bloodPressureRecordDiastolic: number;
  humanRecordedAt: string;
  formattedValue: string;
  vitalSignName: string;
  edited: boolean;
  author: ClinicalAuthor | null;
}

export type VitalSignRecordGroup = {
  recordedAt: string;
  humanRecordedAt: string;
  records: VitalSignRecord[];
}

export interface VitalSignRecordsPdf {
  headers: AxiosHeaders;
  data: Blob;
}

export const vitalSignRecordsApi = {
  index(patientId: number, vitalSignId: number, startDate?: string, endDate?: string): Promise<VitalSignRecord[]> {
    let url = `${BASE_PATH}?patient_id=${patientId}&vital_sign_id=${vitalSignId}`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;

    return api({
      method: 'get',
      url,
    }).then(response => response.data.vitalSignRecords);
  },
  latestIndex(patientId: number): Promise<VitalSignRecord[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?patient_id=${patientId}`,
    }).then(response => response.data.vitalSignRecords);
  },
  indexByShift(patientId: number, shiftId: number): Promise<VitalSignRecord[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?patient_id=${patientId}&shift_id=${shiftId}`,
    }).then(response => response.data.vitalSignRecords);
  },
  groupedIndex(patientId: number, startDate?: string, endDate?: string): Promise<VitalSignRecordGroup[]> {
    let url = `${BASE_PATH}?patient_id=${patientId}&grouped=true`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;

    return api({
      method: 'get',
      url,
    }).then(response => response.data.vitalSignRecordGroups);
  },
  indexAsPdf(patientId: number, startDate?: string, endDate?: string): Promise<VitalSignRecordsPdf> {
    let url = `${BASE_PATH}.pdf?patient_id=${patientId}&grouped=true`;
    if (startDate) url += `&start_date=${startDate}`;
    if (endDate) url += `&end_date=${endDate}`;

    return api({
      method: 'get',
      url,
      responseType: 'blob',
    });
  },
};
